const parseKmlCoords = (text: string): [number, number][] => {
    const doc = new DOMParser().parseFromString(text, "text/xml")
    const nodes = doc.getElementsByTagName("coordinates")
    const coords: [number, number][] = []
    for (let i = 0; i < nodes.length; i++) {
        const raw = nodes[i].textContent ?? ""
        for (const tuple of raw.trim().split(/\s+/)) {
            const [lonStr, latStr] = tuple.split(",")
            const lon = parseFloat(lonStr)
            const lat = parseFloat(latStr)
            if (!isNaN(lon) && !isNaN(lat)) coords.push([lon, lat])
        }
    }
    return coords
}

const parseGpxCoords = (text: string): [number, number][] => {
    const doc = new DOMParser().parseFromString(text, "text/xml")
    const nodes = doc.getElementsByTagName("trkpt")
    const coords: [number, number][] = []
    for (let i = 0; i < nodes.length; i++) {
        const lon = parseFloat(nodes[i].getAttribute("lon") ?? "")
        const lat = parseFloat(nodes[i].getAttribute("lat") ?? "")
        if (!isNaN(lon) && !isNaN(lat)) coords.push([lon, lat])
    }
    return coords
}

export const parseFlightPathFile = async (file: File): Promise<[number, number][]> => {
    const text = await file.text()
    const ext = file.name.toLowerCase().split(".").pop()
    return ext === "gpx" ? parseGpxCoords(text) : parseKmlCoords(text)
}
